import { render, staticRenderFns } from "./preview-input.vue?vue&type=template&id=38881568&"
import script from "./preview-input.vue?vue&type=script&lang=js&"
export * from "./preview-input.vue?vue&type=script&lang=js&"
import style0 from "./preview-input.vue?vue&type=style&index=0&id=38881568&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports